import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-shopify-identity-merchant',
  templateUrl: './help-shopify-identity-merchant.component.html',
  styleUrls: ['./help-shopify-identity-merchant.component.scss']
})
export class HelpShopifyIdentityMerchantComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
